import { RestService } from "./RestService";

export class RefundService extends RestService {
  constructor() {
    super("/api/v1/refunds");
  }
}
